import { useState } from "react";

import { PlaceholderImg } from "../../new-client-dashboard/common/placeholder";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import TextPanel from "../../common/TextPanel";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import VerifiedIcon from "../../../assets/verified_yes.png";
import NonVerifiedIcon from "../../../assets/verifiedno.png";
import InformationPanel from "../../common/InformationPanel";

const DogBiteTab = () => {
  const [showDocument, setShowDocument] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);

  const handleGenrateDocument = (instanceId) => {
    setInstanceIdForGenragteDoc(instanceId);
    setShowDocument(true);
  };

  const DogBiteInfo = [
    { label: "Ambulance", value: "yes" },
    { label: "Emergency Room", value: "yes" },
    { label: "Broken Skin", value: "yes" },
    { label: "Report Taken", value: "yes" },
    {
      label: "Number of bites",
      value: 2,
    },
  ];

  const DogBiteLocBtn = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: (id, name) => handleGenrateDocument(id, name),
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const dogBiteInfoBtns = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-avatar has-avatar-icon has-cover-img m-l-5",
      imgSrc: hoveredIndex ? VerifiedIcon : NonVerifiedIcon,

      imgClassName: "ic ic-15 m-r-5",
      buttonText: "9/20/25 10:30 AM",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {
        setHoveredIndex(true);
      },
      onMouseLeave: () => {
        setHoveredIndex(null);
      },
      onClick: () => {
        setHoveredIndex(true);
      },
    },
  ];

  return (
    <>
      <div
        className="d-flex m-b-5"
        style={{
          gap: "5px",
        }}
      >
        <PlaceholderImg />
        <div className="d-flex flex-wrap" style={{ gap: "5px", width: "100%" }}>
          {/*  */}
          <div className="min-w-260px-client">
            <InformationPanel
              panel_name="Accident Information"
              data={DogBiteInfo}
              onSelectReport={() => {}}
              defaultLength={5}
              panelClassName="min-height-auto p-r-5"
              hasBtn={true}
              colorGiven={"var(--primary-25)"}
              buttonData={dogBiteInfoBtns}
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={""}
              panel_name="Dog Attack Location"
              className="m-b-0"
              pageName={"Dog Bite"}
              websiteURL={""}
              name={""}
              address1={""}
              address2={""}
              city={""}
              state={""}
              zip_code={""}
              phone_number={""}
              email={""}
              onSelectObject={() => {}}
              buttonData={DogBiteLocBtn}
              genrate_doc_address=""
            />
          </div>

          <div className="min-w-260px-client">
            <TextPanel
              object={{
                statement_summary: "",
              }}
              panel_name="Attack Description"
              className="info-div-accident-statement-summary"
              primaryText="Click to add Attack Description"
            />
          </div>
          <div className="min-w-260px-client">
            <TextPanel
              object={{
                statement_summary: "",
              }}
              panel_name="Dog Description"
              className="info-div-accident-statement-summary"
              primaryText="Click to add Dog Description"
            />
          </div>

          <div
            className=""
            style={{
              flex: 1,
              minHeight: "155px",
              maxHeight: "155px",
              paddingRight: "0px",
              scrollbarWidth: "none",
              minWidth: "400px",
            }}
          >
            <p className="menu-bar-style columnsTitle text-center">Notes</p>

            <TreatmentNotesSection
              entity_type={"Dog Bite"}
              record_id={""}
              module={"Dog Bite"}
              pagePanels={0}
            />
          </div>
        </div>
      </div>
      {showDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => setShowDocument(false)}
          PageEntity="Death"
          instanceId={instanceIdForGenrateDoc}
        />
      )}
    </>
  );
};

export default DogBiteTab;
